import { render, staticRenderFns } from "./aRmsDayGeneralEvents.vue?vue&type=template&id=5b01a6c5&scoped=true"
import script from "./aRmsDayGeneralEvents.vue?vue&type=script&lang=js"
export * from "./aRmsDayGeneralEvents.vue?vue&type=script&lang=js"
import style0 from "./aRmsDayGeneralEvents.vue?vue&type=style&index=0&id=5b01a6c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b01a6c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VChip,VCol,VIcon,VRow})
